<template>
  <div class="nestedInnerItem">
    <cvt-select
      :value="componentData"
      mode="dropdown"
      :background-mode="mode"
      :floating-label="false"
      :label="alignmentLabel"
      @input="(value) => componentData = value"
    >
      <option
        v-for="style in alignmentStyles"
        :key="style"
        :value="style"
        v-text="style"
      />
    </cvt-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as _ from "lodash";
import * as actions from "@/js/store/modules/actions";
import * as getters from "@/js/store/modules/getters";

export default {
  name: "Alignment",
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
    componentKey: {
      type: String,
      required: true,
    },
    alignmentLabel: {
      type: String,
      required: true,
    }
  },
  data () {
    return {
      alignmentStyles: [
        'self-start',
        'self-end',
        'flex-start',
        'flex-end',
        'center',
        'baseline',
        'stretch',
      ],
    }
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED
    }),
    componentData: {
      get() {
        return _.get(
          this.selected,
          this.componentKey.replaceAll('/', '.'),
          "self-start"
        )
      },
      set(value) {
        return this.updateProp({ key: this.componentKey, value })
      },
    },
  },
  methods: {
    ...mapActions({
      updateProp: actions.SELECTOR_UPDATE_PROP,
    }),
  }
}
</script>


<style scoped lang="scss">

</style>